import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { SideBarMode, Resource, ResourcesStore } from '../../types'
import { setSelectedResource, updateResource, archiveResource } from './resourcesStoreMethods'

export const useResourcesStore = create<ResourcesStore>()(
  immer((set) => ({
    timezone: 'UTC',
    setTimezone: (timezone: string) =>
      set((draft) => {
        draft.timezone = timezone
      }),
    isSideBarOpen: false,
    toggleSideBar: (mode?: SideBarMode) =>
      set((draft) => {
        draft.isSideBarOpen = !draft.isSideBarOpen
        draft.sideBarMode = draft.isSideBarOpen ? mode : undefined
      }),
    areResourcesLoading: true,
    resources: [],
    selectedResource: null,
    setResources: (resources: Resource[]) =>
      set((draft) => {
        draft.resources = resources
      }),
    setSelectedResource: (selectedResource: Resource | null) =>
      set((draft) => setSelectedResource(selectedResource)(draft)),
    setAreResourcesLoading: (areResourcesLoading: boolean) =>
      set((draft) => {
        draft.areResourcesLoading = areResourcesLoading
      }),
    addResource: (resource: Resource) =>
      set((draft) => {
        draft.resources.unshift(resource)
      }),
    updateResource: (updatedResource: Resource) =>
      set((draft) => updateResource(updatedResource)(draft)),
    archiveResource: (resourceId: string) => set((draft) => archiveResource(resourceId)(draft)),
  }))
)
